import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import styles from "./ProductListingPage.module.css";
import Select from 'react-select';
import { Accordion } from "react-bootstrap";

import PartialBanner, { IPartialBanner } from "../../components/partialBanner/PartialBanner";
import PartialProductCard, { IPartialProductCard } from "../../components/partialProductCard/PartialProductCard"
import { get } from "../../utilities/apiClient";
import { colorCodes, productListingType } from '../../utilities/settings'
import { useLocation, useParams } from "react-router-dom";
import HeadingSection from "../../components/headingSection/HeadingSection";

interface ISelector {
    value: string;
    label: string;
}

const sortByOptions: ISelector[] = [
    { value: 'Name_ASC', label: 'Name(A - Z)' },
    { value: 'Name_DESC', label: 'Name(Z - A)' },
    { value: 'Price_ASC', label: 'Price(Low to High)' },
    { value: 'Price_DESC', label: 'Price(High to Low)' },
];
const webImg = "https://sajkoaonline.blob.core.windows.net/jkoa/carousel/Main-Carousel-Banner-Samsung-mobiles-1920x1080.jpg";
const mobImg = "https://sajkoaonline.blob.core.windows.net/jkoa/carousel/mobile/Main-Carousel-Banner-Samsung-mobiles-mobile-version-375x750px.jpg";

// const banner: IPartialBanner = { bannerId: 1, bannerName: "Banner", webImageURL: webImg, mobileImageURL: mobImg }

export function selectColorCode(n: number) {
    var val = (n % 4);
    return val;
}

const headerDescription = {
    departmentName: "DISCOVER OUR PRODUCTS",
    description: ["Make the best out of your time and implement solutions that support your growth. We offer a variety of products to improve the efficiency in your business and as well as your home."]
}

function ProductListingPage() {
    // var urldata = useSelector((state: RootState) => state.urlData);

    const [isWeb, setIsWeb] = useState<boolean>(true);
    const responsive = useSelector((state: RootState) => state.responsive);
    const [departmentOptions, setDepartmentOptions] = useState<any>([]);
    const [subDepartmentOptions, setSubDepartmentOptions] = useState<any>();
    const [categoryOptions, setCategoryOptions] = useState<any>([]);
    const [brandOptions, setBrandOptions] = useState<any>([]);

    const [departmentOptionsDB, setDepartmentOptionsDB] = useState<any>([]);
    const [subDepartmentOptionsDB, setSubDepartmentOptionsDB] = useState<any>([]);
    const [brandOptionsDB, setBrandOptionsDB] = useState<any>([]);
    const [categoryOptionsDB, setCategoryOptionsDB] = useState<any>([]);

    const [productList, setProductList] = useState<IPartialProductCard[]>([]);
    const [banner, setBanner] = useState<any>();

    const [totalPages, setTotalPages] = useState(0);
    const [scrolling, setScrolling] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);

    const [brandId, setBrand] = useState("");
    const [departmentId, setDepartment] = useState("");
    const [subDepartmentId, setSubDepartment] = useState("");
    const [categoryId, setCategory] = useState<string[]>([]);
    const [categoryDisplay, setCategoryDisplay] = useState<any>([]);
    const [offerId, setOffer] = useState("");
    const [sortBy, setSortBy] = useState<ISelector>(sortByOptions[0]);
    const [itemDescription, setItemDescription] = useState("");
    const [header, setHeader] = useState<any>(headerDescription);

    const [filteredLink, setFilteredLink] = useState<boolean>();
    //!url data
    const [listingType, setListingType] = useState<any>('');
    const [listingId, setListingId] = useState<any>(null);
    const [listingId2, setListingId2] = useState<any>(null);

    const searchbefore = useLocation().search;
    const urlparam = useLocation().pathname;
    const search = (searchbefore.match(new RegExp("/", "g")) || []).length === 1 ? searchbefore.substring(0, searchbefore.lastIndexOf("/")) : searchbefore

    const lastindex = urlparam.split("/")[urlparam.split("/").length - 1].replace(/[/_]/g, " ");
    const beforelastindex = urlparam.split("/")[urlparam.split("/").length - 2].replace(/[/_]/g, " ");

    useEffect(() => {
        if (search !== null && search !== '') {
            setListingType(new URLSearchParams(search).get('lt'));
            setListingId(new URLSearchParams(search).get('id'));
            setListingId2(new URLSearchParams(search).get('id2'));
        } else {
            if (lastindex.toLowerCase() === productListingType.all) {
                setListingType(productListingType.all);
                setListingId(null);
                setListingId2(null);
            } else if (beforelastindex.toLowerCase() === productListingType.search) {
                setListingType(productListingType.search);
                setListingId(lastindex);
                setListingId2(null);
            } else {
                get("WebModule/GetUrlList", {}, false)
                    .then(res => {
                        var response: any = res;
                        if (response.data.statusCode === 200) {
                            const findBrandURL = response.data.result.brandURL.find((obj: any) => obj.brandName.toLowerCase() === lastindex.toLowerCase())
                            const findDepartmentURL = response.data.result.departmentURL.find((obj: any) => obj.departmentName.toLowerCase() === lastindex.toLowerCase())
                            const findOfferURL = response.data.result.offerURL.find((obj: any) => obj.promotionCode.toLowerCase() === lastindex.toLowerCase())
                            const findSubDepartmentURL = response.data.result.subDepartmentURL.find((obj: any) => obj.subDepartmentName.toLowerCase() === lastindex.toLowerCase() && obj.departmentName.toLowerCase() === beforelastindex.toLowerCase())
                            if (findSubDepartmentURL) {
                                setListingType(productListingType.depSubDep);
                                setListingId(findSubDepartmentURL.departmentId);
                                setListingId2(findSubDepartmentURL.subDepartmentId);
                            } else if (findBrandURL) {
                                setListingType(productListingType.brand);
                                setListingId(findBrandURL.brandId);
                                setListingId2(null);
                            } else if (findDepartmentURL) {
                                setListingType(productListingType.department);
                                setListingId(findDepartmentURL.departmentId);
                                setListingId2(null);
                            } else if (beforelastindex.toLowerCase() === productListingType.offer.toLowerCase() && findOfferURL) {
                                setListingType(productListingType.offer);
                                setListingId(findOfferURL.promotionHeaderId);
                                setListingId2(null);
                            } else {
                                setListingType('');
                                setListingId(null);
                                setListingId2(null);
                            }
                        }
                        else {
                            console.log(response.data.errorList)
                        }
                    });
            }
        }
        return () => {
            setListingType('');
            setListingId(null);
            setListingId2(null);
        }
    }, [lastindex, beforelastindex])

    useEffect(() => {
        if (listingType == productListingType.all) {
            setFilteredLink(false);
        }
        else {
            setFilteredLink(true);
        }
    }, [listingType])
    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
        if (listingType == productListingType.search && listingId) {
            resetProducts();
            setItemDescription(listingId);
        }
        getPageData();
        window.addEventListener("scroll", (e) => {
            handleScrollForProductLoading(e);
        })
        return () => {
            window.removeEventListener('scroll', handleScrollForProductLoading);
        }
    }, [listingType])

    useEffect(() => {
        if (page > 1) {
            lazyLoadProducts();
        }
    }, [page])

    useEffect(() => {
        if (scrolling === true && totalPages == 0)
            loadMoreProducts();
    }, [scrolling])

    //params from parent
    useEffect(() => {
        if (listingType == productListingType.department) {
            resetProducts();
            var cat = listingId === null ? "" : listingId;
            setDepartment(cat);
        }
        else if (listingType == productListingType.brand) {
            resetProducts();
            var brand = listingId === null ? "" : listingId;
            setBrand(brand);
        }
        else if (listingType == productListingType.offer) {
            resetProducts();
            var offer = listingId === null ? "" : listingId;
            setOffer(offer);
        }
    }, [listingId])

    useEffect(() => {
        if (listingType == productListingType.departmentBrand) {
            resetProducts();
            var cat = listingId === null ? "" : listingId;
            var brand = listingId2 === null ? "" : listingId2;
            setBrand(brand);
            setDepartment(cat);
        }
    }, [listingId2])

    useEffect(() => {
        if (listingType == productListingType.depSubDep) {
            resetProducts();
            var dep = listingId === null ? "" : listingId;
            var subDep = listingId2 === null ? "" : listingId2;
            setDepartment(dep);
            setSubDepartment(subDep);
        }
    }, [listingId2])

    //filters data setting
    useEffect(() => {
        setDepartmentOptions(departmentOptionsDB)
    }, [departmentOptionsDB])


    // START --> "filter subdepartment, category and brands data as soon as caught from link"
    useEffect(() => {
        if (listingType == productListingType.depSubDep || listingType == productListingType.department) {
            setSubDepartmentOptions(subDepartmentOptionsDB.filter((a: any) => a.departmentId == departmentId))
        }
    }, [subDepartmentOptionsDB])

    useEffect(() => {
        if (listingType == productListingType.depSubDep) {
            setCategoryOptions(categoryOptionsDB.filter((a: any) => a.departmentId == departmentId && a.subDepartmentId == subDepartmentId))
        }
    }, [categoryOptionsDB])

    useEffect(() => {
        var result;
        if (listingType == productListingType.all || listingType == productListingType.brand) {
            result = brandFilter(brandOptionsDB);
        }
        else if (listingType == productListingType.department) {
            var depFilter = brandOptionsDB.filter((a: any) => a.departmentId == departmentId);
            result = brandFilter(depFilter);
        }
        else if (listingType == productListingType.depSubDep) {
            var subDepFilter = brandOptionsDB.filter((a: any) => a.departmentId == departmentId && a.subDepartmentId == subDepartmentId);
            result = brandFilter(subDepFilter);
        }
        else if (listingType == productListingType.departmentBrand) {
            var depFilter = brandOptionsDB.filter((a: any) => a.departmentId == departmentId);
            result = brandFilter(depFilter);
        }
        setBrandOptions(result)
    }, [brandOptionsDB])
    //END

    useEffect(() => {
        if (filteredLink == false) {
            setSubDepartment("");
        }
        setCategory([]);
        setCategoryDisplay([]);
        if (departmentId == undefined) {
            setSubDepartmentOptions(null);
        }
        else if (subDepartmentOptionsDB.length != 0) {
            setSubDepartmentOptions(subDepartmentOptionsDB.filter((a: any) => a.departmentId == departmentId))
        }
    }, [departmentId])

    useEffect(() => {
        setCategory([]);
        setCategoryDisplay([]);
        if (departmentId == undefined) {
            setCategoryOptions(null);
        }
        else if (categoryOptionsDB != undefined) {
            setCategoryOptions(categoryOptionsDB.filter((a: any) => a.departmentId == departmentId && a.subDepartmentId == subDepartmentId))
        }
    }, [subDepartmentId])


    //set brands dropdown according to filter
    useEffect(() => {
        if (brandOptionsDB.length != 0) {
            var filter;
            if ((categoryId.length != 0)) {
                var categories = categoryId.map(Number);
                filter = brandOptionsDB.filter((a: any) => a.departmentId == departmentId && a.subDepartmentId == subDepartmentId && categories.filter(b => b == a.categoryId));
            }
            else if ((subDepartmentId !== "") && (subDepartmentId != undefined)) {
                filter = brandOptionsDB.filter((a: any) => a.departmentId == departmentId && a.subDepartmentId == +subDepartmentId);
            }
            else if ((departmentId != undefined) && (departmentId != "")) {
                filter = brandOptionsDB.filter((a: any) => a.departmentId == +departmentId);
            }
            else {
                filter = brandOptionsDB;
            }
            var result = brandFilter(filter);
            setBrandOptions(result)
        }
    }, [departmentId, subDepartmentId, categoryId])

    useEffect(() => {
        lazyLoadProducts();
    }, [departmentId, subDepartmentId, categoryId, brandId, sortBy, itemDescription, offerId])

    function parameters() {
        if (listingType == productListingType.department) {
            return listingId;
        }
        else {
            return "";
        }
    }
    const brandFilter = (list: any) => {
        return list.reduce((unique: any, o: any) => {
            if (!unique.some((obj: any) => obj.label === o.label && obj.value === o.value)) {
                unique.push(o);
            }
            return unique;
        }, []);
    }
    function getPageData() {
        get("WebModule/GetProductListingPage", {
            departmentId: parameters()
        }, false)
            .then(res => {
                var response: any = res;
                if (response.data.statusCode === 200) {
                    setBanner(response.data.result.banner);
                    if (response.data.result.header != undefined) {
                        setHeader(response.data.result.header);
                    }
                    setDepartmentOptionsDB(response.data.result.departments)
                    setSubDepartmentOptionsDB(response.data.result.subDepartments)
                    setCategoryOptionsDB(response.data.result.categories)
                    setBrandOptionsDB(response.data.result.brands)
                }
                else {
                    console.log(response.data.errorList)
                }
            }
            );
    }
    /*-- Start of Load product details region --*/
    const handleScrollForProductLoading = (e: any) => {
        if (scrolling)
            return

        if (totalPages > 0) {
            return
        }

        var h: any = document.documentElement,
            b: any = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

        var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

        if (percent > 70 && !scrolling) {
            setScrolling(true);
        }
    };

    const lazyLoadProducts = () => {
        //if listingid has a value, brandid or departmentid or itemdescription must have a value or undefined
        //undefined when clear the drop down
        //else listingid can be empty
        //then only lazy loading works
        if ((listingId != "" && (brandId != "" || departmentId != "" || subDepartmentId != "" || itemDescription != "" || offerId != "")) || listingType == productListingType.all) {
            get('WebModule/LoadProducts', {
                fromCount: ((perPage * page) - perPage),
                toCount: perPage,
                departmentId: departmentId,
                subDepartmentId: subDepartmentId,
                categoryId: categoryId ? categoryId.toString() : "",
                itemDescription: itemDescription,
                sortBy: sortBy?.value,
                brandId: brandId,
                offerId: offerId
            }, true)
                .then((response: any) => {
                    if (response.data.statusCode === 200) {

                        if (response.data.result !== null && response.data.result.length > 0) {
                            setProductList([...productList, ...response.data.result]);
                            setTotalPages(0);
                            setScrolling(false);
                        } else {
                            setTotalPages(1);
                            setScrolling(true);
                        }
                    }
                    else {
                        console.log(response.data.errorList)
                    }
                })
        }
    };

    const loadMoreProducts = () => {
        setPage(prePage => prePage + 1);
    };
    /*-- End of Load product details region --*/


    function departmentSubmit(data: any) {
        resetLinkData();
        if (data && data.value == departmentId) {
            return;
        }
        setBrand("");
        resetProducts();
        setDepartment(data?.value);
    }
    function subDepartmentSubmit(data: ISelector) {
        if (data && data.value == subDepartmentId) {
            return;
        }
        setBrand("");
        resetLinkData();
        resetProducts();
        setSubDepartment(data?.value);
    }
    function categorySubmit(data: any) {
        setBrand("");
        setCategory([]);
        resetProducts();
        setCategory(data.map((a: any) => a.value));
        setCategoryDisplay(data);
    }

    function brandSubmit(data: ISelector) {
        if (data && data.value == brandId) {
            return;
        }
        resetProducts();
        setBrand(data?.value);
    }

    function sortBySubmit(data: ISelector) {
        if (data == sortBy) {
            return;
        }
        resetProducts();
        setSortBy(data);
    }

    function resetProducts() {
        window.scroll(0, 0);
        setPage(1);
        setTotalPages(0)
        setScrolling(false);
        setProductList([]);
        setItemDescription("");
    }

    function resetLinkData() {
        setFilteredLink(false);
    }

    return (
        <React.Fragment>
            {/* {!banner ?
                null
                :
                <PartialBanner banner={banner} />
            } */}

            <div className={`container ${styles.container}`}>
                <Row>
                    <HeadingSection
                        subHeading={null}
                        mainHeading={header.departmentName}
                        content={header.description}
                    />
                </Row>
                <Row>
                    {isWeb ?
                        <div className={`${styles.filtersContainer} ${styles.commonfilterContainer}`}>
                            <Row >
                                <Col lg="9" md="9" xs="9" className={`${styles.filters}`}>
                                    <Row>
                                        <Col lg="3" md="3" xs="3">
                                            <Select
                                                options={departmentOptions}
                                                value={departmentOptions ? departmentOptions.filter((a: ISelector) => a.value == departmentId)[0] : null}
                                                onChange={(e: any) => departmentSubmit(e)}
                                                placeholder="Departments"
                                                isClearable={true}
                                            />
                                        </Col>
                                        <Col lg="3" md="3" xs="3">
                                            <Select
                                                isDisabled={subDepartmentOptions == null || subDepartmentOptions.length == 0}
                                                options={subDepartmentOptions}
                                                value={subDepartmentId && subDepartmentOptions ? subDepartmentOptions.filter((a: ISelector) => a.value == subDepartmentId)[0] : null}
                                                onChange={(e: any) => subDepartmentSubmit(e)}
                                                placeholder="Sub Departments"
                                                isClearable={true}
                                            />
                                        </Col>
                                        <Col lg="3" md="3" xs="3">
                                            <Select
                                                isDisabled={categoryOptions == null || categoryOptions.length == 0}
                                                options={categoryOptions}
                                                value={categoryDisplay}
                                                onChange={(e: any) => categorySubmit(e)}
                                                placeholder="Categories"
                                                isClearable={true}
                                                isMulti
                                            />
                                        </Col>
                                        <Col lg="2" md="2" xs="2">
                                            <Select
                                                options={brandOptions}
                                                value={brandId != "" && brandOptions ? brandOptions.filter((a: ISelector) => a.value == brandId)[0] : null}
                                                onChange={(e: any) => brandSubmit(e)}
                                                placeholder="Brands"
                                                isClearable={true}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col lg="3" md="3" xs="3" className={`${styles.filters}`}>
                                    <Row>
                                        <Col lg="3" md="3" xs="3">
                                            <p style={{ marginTop: "revert" }}>SORT BY</p>
                                        </Col>
                                        <Col lg="9" md="9" xs="9">
                                            <Select
                                                options={sortByOptions}
                                                value={sortBy}
                                                onChange={(e: any) => sortBySubmit(e)}
                                                placeholder="Default"
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        :
                        <Accordion style={{ zIndex: 20 }}>
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                    <i style={{ color: "#000000" }} className="fas fa-sliders-h"></i>
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <Row >
                                            <Row>
                                                <p style={{ marginTop: "revert" }}>FILTER</p>
                                            </Row>
                                            <Row style={{ paddingBottom: "5px" }}>
                                                <Select
                                                    options={departmentOptions}
                                                    value={departmentOptions.filter((a: ISelector) => a.value == departmentId)[0] || null}
                                                    onChange={(e: any) => departmentSubmit(e)}
                                                    placeholder="Departments"
                                                    isClearable={true}
                                                />
                                            </Row>
                                            <Row style={{ paddingBottom: "5px" }}>
                                                <Select
                                                    isDisabled={subDepartmentOptions == null || subDepartmentOptions.length == 0}
                                                    options={subDepartmentOptions}
                                                    value={subDepartmentId && subDepartmentOptions ? subDepartmentOptions.filter((a: ISelector) => a.value == subDepartmentId)[0] : null}
                                                    onChange={(e: any) => subDepartmentSubmit(e)}
                                                    placeholder="Sub Departments"
                                                    isClearable={true}
                                                />
                                            </Row>
                                            <Row style={{ paddingBottom: "5px" }}>
                                                <Select
                                                    isDisabled={categoryOptions == null || categoryOptions.length == 0}
                                                    options={categoryOptions}
                                                    value={categoryDisplay}
                                                    onChange={(e: any) => categorySubmit(e)}
                                                    placeholder="Categories"
                                                    isClearable={true}
                                                    isMulti
                                                />
                                            </Row>
                                            <Row style={{ paddingBottom: "5px" }}>
                                                <Select
                                                    options={brandOptions}
                                                    value={brandId != "" && brandOptions ? brandOptions.filter((a: ISelector) => a.value == brandId)[0] : null}
                                                    onChange={(e: any) => brandSubmit(e)}
                                                    placeholder="Brands"
                                                    isClearable={true}
                                                />
                                            </Row>
                                        </Row>
                                        <Row>
                                            <Row>
                                                <Col lg="4" md="12" xs="12">
                                                    <p style={{ marginTop: "revert" }}>SORT BY</p>
                                                </Col>
                                                <Col lg="8" md="12" xs="12">
                                                    <Select
                                                        options={sortByOptions}
                                                        value={sortBy}
                                                        onChange={(e: any) => sortBySubmit(e)}
                                                        placeholder="Default"
                                                    />
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    }
                </Row>
                <Row className={`${styles.productCardConatiner}`} >
                    {productList.map((item: IPartialProductCard, index) => {
                        return (
                            <Col xl="3" lg="3" md="6" sm="6" xs="6" >
                                <PartialProductCard key={item.itemId} productCard={item} colorCode={colorCodes[selectColorCode(index)]}></PartialProductCard>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </React.Fragment>
    )
}

export default ProductListingPage;